// extracted by mini-css-extract-plugin
export default {"page":"eX-z","cartModal":"fX-z","checkout":"gX-z","placeholder":"hX-z","account":"iX-z"};